export function generateParams(args: any): string {
  // Remove values that have empty values or are empty arrays
  const sanitizedArgs = Object.entries(args).filter(([key, value]) => {
    return (value !== "" || (Array.isArray(value) && value.length));
  });

  // Create a new object from the filtered values
  const newArgs = Object.fromEntries(sanitizedArgs) as any;

  if (!Object.keys(newArgs).length) {
    return "";
  }

  return "?" + new URLSearchParams(newArgs);
}